var React = require('react');

function ArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0H40V40H0z","transform":"rotate(90 20 20) matrix(1 0 0 -1 0 40)","key":0}),React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","d":"M14 18L20 22 26 18","transform":"rotate(90 20 20) rotate(-90 20 20)","key":1})]));
}

ArrowIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 40 40"};

module.exports = ArrowIcon;

ArrowIcon.default = ArrowIcon;
